export default [
    {
        title: "mainmenu.support",
        route: "support",
        icon: "headset",
        resource: "support",
        action: "read",
    },
];
